import { WidgetProps } from '@rjsf/utils';

import Input from 'design-system/components/Input';

export function InputWidget({
  id,
  value,
  disabled,
  onChange,
  options,
  schema,
  rawErrors = [],
}: WidgetProps) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value === '' ? options.emptyValue : event.target.value);
  };

  return (
    <Input
      id={id}
      value={value}
      disabled={disabled}
      onChange={handleChange}
      hasError={rawErrors.length > 0}
      aria-invalid={rawErrors.length > 0}
      aria-label={schema.title || id}
    />
  );
}
